import { render } from "./TouristeChoixCalcul.vue?vue&type=template&id=1f60baaa"
import script from "./TouristeChoixCalcul.vue?vue&type=script&lang=js"
export * from "./TouristeChoixCalcul.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__